import React from "react";

interface LoadingOverlayProps {
  message?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  message = "Loading...",
}) => {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background">
      <div className="h-5 w-5 animate-spin rounded-full border-2 border-border border-t-foreground mb-3"></div>
      <p className="text-sm text-muted-foreground">{message}</p>
    </div>
  );
};
